import { Component } from "@angular/core";
import { FeatureFlags, IDatevTenantInfo } from "@vierkant-software/types__api";
import { DraftForm, DraftFormType } from "src/app/modules/ngx-draft";
import { Option } from "src/util/types/global";
import { IFrontendUser } from "../../contract.interfaces";

@Component({
    templateUrl: './personal-data.step.haml',
    styleUrls:   ['./personal-data.step.sass'],
    standalone:  false
})
export class UserPersonalDataStep {

    @DraftForm() form: DraftFormType<IFrontendUser>;

    fDATEV = FeatureFlags.datev;
    datevTenantInfos: Option<string>[] = [];

    readonly defaultDatevInfo: Option = {
        label: "Aktuellen Standardmandanten verwenden",
        value: "",
    };

    onResolve(data: {datevTenantInfos?: IDatevTenantInfo[]}) {
        this.datevTenantInfos = [];
        if (!data.datevTenantInfos?.length) return;
        data.datevTenantInfos.filter(d => !d.isActive).forEach(d => d.title += " (inaktiv)");
        this.datevTenantInfos.push(this.defaultDatevInfo, ...data.datevTenantInfos.map(d => ({
            label: d.title,
            value: d.ID,
        })));
    }
}
